import DetailsRow from "./DetailsRow";
import OvertimeCellRenderer from "../renderers/OvertimeCellRenderer";
import OvertimeDayDetailsCellRenderer from "../renderers/OvertimeDayDetailsCellRenderer";

export default class OvertimeRow extends DetailsRow {
    createRowHeaderRenderer() {
        let topBorderClass = "";
        if (this.isFirstChildRow())
            topBorderClass = "detailsRowSeparator";
        else if (this.hasRowSeparator())
            topBorderClass = "overtimeTopBorder";
        return new OvertimeCellRenderer(topBorderClass, this.getAdditionalClass("Header"));
    }

    createLockCellRenderer() {
        return new OvertimeDayDetailsCellRenderer("odd DayDetailsCell",
            this.getTopBorderClassName(),
            this.getAdditionalClass(""));
    }

    getTopBorderClassName() {
        if (this.isFirstChildRow())
            return "detailsRowSeparator";
        if (this.hasRowSeparator())
            return "detailsInnerOvertimeRowSeparator";

        return ""
    }

    hasRowSeparator() {
        let childRows = this.getParentRow().getChildRows();
        for (let i = 0; i < childRows.length; i++) {
            let childRow = childRows[i];
            if (childRow instanceof OvertimeRow) {
                return childRow.getRowIdx() == this.getRowIdx();
            }
        }
    }

    getAdditionalClass(postfix) {
        if (!this.hasRowSeparator())
            return "secondOvertimeRow" + postfix;
        else if (this.getParentRow().getLastChildRow().getRowIdx() != this.getRowIdx())
            return "firstOvertimeRow" + postfix;

        return "";
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/OvertimeRow.js